import { useTranslation } from 'react-i18next';
import { menuPaddingLeft } from 'v5/patterns/sidebar/menuPadding';
import { cn } from 'v5/platform/dom/cn';

export type EnterpriseSidebarEmptyStateProps = {
  messageKey: 'emptyWorkspaces' | 'emptyTeams';
  level?: number;
  className?: string;
};

export function EnterpriseSidebarEmptyState({
  messageKey,
  level = 0,
  className
}: EnterpriseSidebarEmptyStateProps) {
  const { t } = useTranslation('core', { keyPrefix: 'enterprise' });

  return (
    <div
      className={cn('py-2 pr-3', className)}
      style={{ paddingLeft: menuPaddingLeft(level) }}
    >
      <p className="text-[13px] text-fg-muted">{t(messageKey)}</p>
      <p className="mt-0.5 text-xs text-fg-muted/80">
        {t(`${messageKey}Hint`)}
      </p>
    </div>
  );
}
